import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const ViewMore = () => {
  const navigate = useNavigate();
  const stateName = sessionStorage.getItem("selectedState");
  const siteId = sessionStorage.getItem("selectedSiteId");
  const [statusClass, setStatusClass] = useState("offline");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [controllerDate, setControllerDate] = useState("");
  const [isOnline, setIsOnline] = useState(false);
  const [hupsdata, setHupsData] = useState(null);
  const [dateTime, setDateTime] = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
  // console.log(siteId);
  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/get_data_by_site");
    }
  }, [navigate]);
  useEffect(() => {
    const fetchHupsData = async () => {
      const fetchUrlHups = `https://api.bharatnet.sunshineiotronics.com/api/v2/hups/${siteId}`;
      try {
        const response = await fetch(fetchUrlHups);
        const result = await response.json();
        setHupsData(result);

        setControllerDate(result.controller_datetime);

        const currentDate = new Date();
        const siteDate = new Date(
          result.controller_datetime
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("-") +
            " " +
            result.controller_datetime.split(" ")[1]
        );

        setDateTime(result.controller_datetime);

        const diffSeconds = Math.floor((currentDate - siteDate) / 1000);
        console.log(`Time difference in seconds: ${diffSeconds}`);

        if (diffSeconds <= 300) {
          setIsOnline(true);
          setStatusClass("online");
        } else {
          setIsOnline(false);
          setStatusClass("offline");
        }
      } catch (error) {
        console.error("Error fetching hupsdata:", error);
      }
    };
    const fetchData = async () => {
      await fetchHupsData();
    };

    const fetchInitialData = async () => {
      setInitialLoading(true);
      await fetchData();
      setInitialLoading(false);
    };

    // Fetch initial data
    fetchInitialData();

    // Set interval to fetch data every 3 seconds
    const intervalId = setInterval(fetchData, 3000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [siteId]);

  if (initialLoading) {
    return <div>Loading...</div>;
  }
  const breadcrumbs = [
    <Link key="1" sx={{ color: "black" }} href="/dashboard">
      Dashboard
    </Link>,
    <Link key="2" sx={{ color: "black" }} href={`/dashboard`}>
      {stateName}
    </Link>,
    <Link key="3" sx={{ color: "black" }} href={`/${stateName}/displaySite`}>
      Display Sites
    </Link>,
    <Link key="4" sx={{ color: "black" }} href={`/get_data_by_site`}>
      Go Live
    </Link>,
    <Typography key="5" sx={{ color: "text.primary" }}>
      View More
    </Typography>,
  ];
  const alarmStatus = (value) => (
    <div className={`status-indicator ${value == 1 ? "offline" : "online"}`}>
      <div className="status-light"></div>
    </div>
  );
  return (
    <Box m="2rem 3rem">
      <Box display="flex" flexDirection="column" gap={4}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Stack spacing={2}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </Stack>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: "bold" }}
          >
            <div className={`status-indicator ${statusClass}`}>
              <div className="status-light"></div>
              <span className="status-text">
                {siteId} |{" "}
                {hupsdata?.controller_datetime && hupsdata.controller_datetime}{" "}
              </span>
            </div>
          </Typography>
        </Box>
        <Divider sx={{ borderColor: "divider" }} />
        <div className="view-more-container">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography
                variant="h4"
                sx={{
                  textAlign: "center",
                  margin: "1rem",
                  color: "#997D3D",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Alarms
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ backgroundColor: "rgb(250, 223, 186)" }}>
                    <TableRow>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Parameter
                      </TableCell>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Mains Fail
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mains_fail}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Site Battery Low
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.site_battery_low}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>FR Fail</TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.fr_fail}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        System Overload
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.system_overload}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Mains on Battery Discharge
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mains_on_battery_discharge}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Dc Voltage High
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.dc_voltage_high}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>SPD Fail</TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.spd_fail}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>MPPT Fail</TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt_fail}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        AC Under Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.ac_under_voltage}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        AC Over Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.ac_over_voltage}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Li-Ion BMS Communication Lost
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.li_ion_bms_communication_lost}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Low SOC Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_low_soc_warning}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Charge Over Temperature Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_charge_over_temp_warning}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Discharge Over Current Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_discharge_over_current_warning}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Charge Over Current Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_charge_over_current_warning}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Low Cell Voltage Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_low_cell_voltage_warning}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell Over Voltage Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell_over_voltage_warning}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Low Voltage Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_low_voltage_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Over Voltage Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_over_voltage_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell Over Voltage Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell_over_voltage_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell Low Voltage Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell_low_voltage_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Battery Low Voltage Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_batt_low_voltage_warning}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Battery Over Voltage Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_batt_over_voltage_warning}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Charge Over Temperature Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_charge_over_temp_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Charge Low Temperature Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_charge_low_temp_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Discharge Low Temperature Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_discharge_low_temp_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Charge Over Current Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_charge_over_current_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Discharge Over Current Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_discharge_over_current_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Mosfet Over Temperature Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_mosfet_over_temp_warning}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Mosfet Over Temperature Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_mosfet_over_temp_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Discharge Low Temperature Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_discharge_low_temp_warning}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Short Circuit Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_short_circuit_protection}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Battery Status
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_batt_status}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Battery Warning
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_batt_warning}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Battery Protection
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_batt_protection}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Battery Error
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_batt_error}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="h4"
                sx={{
                  textAlign: "center",
                  margin: "1rem",
                  color: "#997D3D",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                System Data
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ backgroundColor: "rgb(250, 223, 186)" }}>
                    <TableRow>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Parameter
                      </TableCell>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        System Serial No.
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.system_serial_no}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        System Make
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.system_make}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Total System Capacity
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.total_system_capacity} VA
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Load Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.load_current} mA
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        AC Mains Run Hours
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.ac_mains_run_hours} Hr
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Load Energy
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.load_energy} Kwh
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        AC Under Voltage Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.ac_under_voltage_set} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        AC Over Voltage Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.ac_over_voltage_set} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        RM Redundant
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rm_redundant}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        RM Lacking
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rm_lacking}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        RM Replaced
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rm_replaced}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <br />
              <Typography
                variant="h4"
                sx={{
                  textAlign: "center",
                  margin: "1rem",
                  color: "#997D3D",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                Rectifier Data
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ backgroundColor: "rgb(250, 223, 186)" }}>
                    <TableRow>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Parameter
                      </TableCell>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Total Installed Rectifiers
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.total_installed_rectifiers}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Number of Working Rectifiers
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.number_of_working_rectifiers}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Number of Faulty Rectifiers
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.number_of_faulty_rectifiers}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rating of Rectifiers
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rating_of_rectifiers} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Output Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_output_current} mA
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Output Power
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_output_power} W
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Output Energy
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_output_energy} Kwh
                      </TableCell>
                    </TableRow>
                    {/* <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Output Current 1
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_output_current_1} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Output Voltage 1
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_output_voltage_1} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Output Current 2
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_output_current_2} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Output Voltage 2
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_output_voltage_2} V
                      </TableCell>
                    </TableRow> */}
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Unit Overload
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_unit_overload} mA
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <br />
              <Typography
                variant="h4"
                sx={{
                  textAlign: "center",
                  margin: "1rem",
                  color: "#997D3D",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                Solar Data
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ backgroundColor: "rgb(250, 223, 186)" }}>
                    <TableRow>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Parameter
                      </TableCell>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Solar Ultimate Capacity
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.solar_ultimate_capacity} KW
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Number of SPV Panel
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.number_of_spv_panel}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rating of SPV Panel
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rating_of_spv_panel} W
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Solar Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.solar_current} mv
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Solar Run Hours
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.solar_run_hours} sec
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Solar Energy
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.solar_energy} Kwh
                      </TableCell>
                    </TableRow>
                    {/* <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Solar VPGM Voltage Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.solar_vpgm_voltage_set} V
                      </TableCell>
                    </TableRow> */}
                  </TableBody>
                </Table>
              </TableContainer>
              <br />
              <Typography
                variant="h4"
                sx={{
                  textAlign: "center",
                  margin: "1rem",
                  color: "#997D3D",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                MPPT Data
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead
                    sx={{
                      backgroundColor: "rgb(250, 223, 186)",
                    }}
                  >
                    <TableRow>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Parameter
                      </TableCell>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Total Installed MPPT
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.total_installed_mppt}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Number of Working MPPT
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.number_of_working_mppt}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Number of Faulty MPPT
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.number_of_faulty_mppt}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Output Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_output_current} mA
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Output Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_output_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Output Power
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_output_power} W
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Delivered Energy
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_delivery_energy} KWH
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Input Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_input_current} mA
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Input Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_input_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Input Power
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_input_power} W
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <br />
              {/* <Typography
                variant="h4"
                sx={{
                  textAlign: "center",
                  margin: "1rem",
                  color: "#997D3D",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                Inverter Data
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ backgroundColor: "rgb(250, 223, 186)" }}>
                    <TableRow>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Parameter
                      </TableCell>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Inverter DC Input Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.inv_dc_input_voltage} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Inverter Bypass AC Input Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.inv_bypass_ac_input_voltage} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Inverter Output Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.inv_output_voltage} V
                      </TableCell>
                    </TableRow>
                    {/* <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Inverter Frequency
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.inv_frequency} Hz
                      </TableCell>
                    </TableRow> */}
              {/* <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Inverter DC Input Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.inv_dc_input_current} A
                      </TableCell>
                    </TableRow> 
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Inverter Output Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.inverter_output_current} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Inverter Temperature
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.inverter_temperature} °C
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer> */}
            </Grid>
          </Grid>
        </div>
        <Divider sx={{ borderColor: "divider" }} />
        <div className="view-more-container">
          <Typography
            variant="h4"
            sx={{
              textAlign: "center",
              margin: "1rem",
              color: "#997D3D",
              fontSize: "24px",
              fontWeight: "bold",
            }}
          >
            Battery Data
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ backgroundColor: "rgb(250, 223, 186)" }}>
                    <TableRow>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Parameter
                      </TableCell>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Battery Capacity
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.battery_capacity} VAh
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Battery Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.battery_current} mA
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Battery Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.battery_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Battery Run Hours
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.battery_run_hours} Hrs
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Battery Discharge Energy
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.battery_discharge_energy} Kwh
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Battery Charge Energy
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.battery_charge_energy} Kwh
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Battery LVD
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.battery_lvd} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Battery LVD Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.battery_lvd_set} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Battery Low Alarm Voltage Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.battery_low_alarm_voltage_set} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Battery Current Limit 1
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.battery_current_limit_1} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Float Voltage Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.float_voltage_set} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Boost Voltage Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.boost_voltage_set} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        DC Voltage High Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.dc_voltage_high_set} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Charging Current Set Max
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_charging_current_set_max} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Charging Current Set Each Module
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_charging_current_set_each_module} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Manufacturer Name
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_manufacturer_name}{" "}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_current}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Pack Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_pack_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>LIB SOC</TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_soc}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>LIB SOH</TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_soh}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cumulative Charging kWh
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cumulative_charging_kwh} Kwh
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cumulative Discharging kWh
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cumulative_discharging_kwh} Kwh
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Max Cell Temperature
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_max_cell_temperature} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cycle Count
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cycle_count}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Total Battery Capacity
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_total_batt_capacity} V/Ah
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 1 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell01_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 2 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell02_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 3 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell03_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 4 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell04_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 5 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell05_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 6 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell06_voltage} mV
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={6}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ backgroundColor: "rgb(250, 223, 186)" }}>
                    <TableRow>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Parameter
                      </TableCell>
                      <TableCell sx={{ fontSize: "16px", color: "#997D3D" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 7 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell07_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 8 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell08_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 9 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell09_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 10 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell10_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 11 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell11_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 12 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell12_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 13 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell13_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 14 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell14_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 15 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell15_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell 16 Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell16_voltage} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        SMPS Cabinet Temperature
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.smps_cabinet_temperature} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell Temp 1
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell_temp1} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell Temp 2
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell_temp2} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell Temp 3
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell_temp3} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell Temp 4
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell_temp4} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell Temp 5
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell_temp5} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell Temp 6
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell_temp6} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB BMS Cooling MOSFET Temp
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_bms_cooling_mosfet_temp} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Module Ambient Temperature
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_module_ambient_temp} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Minimum Cell Temperature
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_minimum_cell_temp} °C
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cell Voltage Difference
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cell_voltage_difference} mV
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Remaining Battery kWh
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_remaining_battery_kwh} WH
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Remaining Battery Cycles
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_remain_battery_cycles}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Estimated Backup Time
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_estimated_backup_time} Min
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Battery Installation Year
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_batt_installation_year}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Battery Installation Month
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_batt_installation_month}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Module Remaining Ah
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_module_remaining_ah} Ah
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cumulative Charge Ah
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cumulative_charging_ah} Ah
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB Cumulative Discharge Ah
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_cumulative_discharging_ah} Ah
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        LIB BMS Version No.
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.lib_bms_version_no} Ah
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </div>
      </Box>
      <br />
    </Box>
  );
};

export default ViewMore;
